import React from "react";
import Icon from "../../assets/Payment/unsucess.svg";

function PaymentUnsucessful() {
  return (
    <>
      <div className="main-container flex justify-center items-center my-[48px] mx-5">
        <div className="inner-content flex flex-col p-[24px] justify-center items-center rounded-[20px] bg-[#fff] shadow-[0px_4px_10px_2px_rgba(211,220,219,0.50)] ">
          <img src={Icon} alt="Success Icon" className="w-20 h-auto" />
          <p className="mt-[24px] mb-[0px] text-[#C90303] text-[24px] font-bold font-inter tracking-[0.024px]">
            Payment Failed !
          </p>
          <p className=" text-[#535862] text-[12px] font-inter mt-[8px] mb-[0px] text-center ">
            Unfortunately executing your payment failed. Can you go back and try
            again.{" "}
          </p>

          <button>
            <div className="mt-[100px] flex justify-center items-center py-[16px] lg:px-[343px] md:px-[200px] px-[100px] rounded-[8px] bg-[#C90303] text-[#fff] text-[14px] font-semibold font-inter ">
              Try Again
            </div>
          </button>

          <button>
            <p className="mt-[24px] text-[#0F161E] text-[14px] font-semibold font-inter">
              Back to Dashboard
            </p>
          </button>
        </div>
      </div>
    </>
  );
}

export default PaymentUnsucessful;
